/* eslint-disable */
import gsap from 'gsap';
import LazyLoad from 'vanilla-lazyload';
import inView from 'in-view';
import Flickity from 'flickity';
import SplitText from 'gsap/SplitText';

const HTML = document.querySelector('html');
const loader = document.querySelector('.loader');

gsap.registerPlugin(SplitText);

class App {
    constructor() {
        this.lazyload = new LazyLoad({
            unobserve_entered: true,
            elements_selector: '.js-lazy',
            threshold: window.innerHeight * 0.8,
            // eslint-disable-next-line camelcase
            callback_enter: ($el) => {
                if ($el.classList.contains('js-lazy-error-placeholder')) {
                    $el.lazyLoadPlaceholder = $el.src;
                } else if ($el.dataset.src == undefined) {
                    const figure = $el.closest('figure');
                    if (figure) figure.classList.add('img-is-loaded');
                }
            },
            callback_loaded: (el) => {
                const figure = el.closest('figure');
                if (figure) figure.classList.add('img-is-loaded');
            },
            // eslint-disable-next-line camelcase
            callback_error: ($el) => {
                if ($el.lazyLoadPlaceholder) {
                    $el.src = $el.lazyLoadPlaceholder;
                }
            },
        });

        const flashlight = document.querySelector('.flashlight');
        if (flashlight) {
            gsap.set(flashlight, { x: window.innerWidth / 2, y: window.innerHeight / 2 });

            window.addEventListener('mousemove', (e) => {
                gsap.set(flashlight, { x: e.clientX, y: e.clientY });
            });
        }

        // Custom cursor
        this.cursor = document.querySelector('.custom-cursor');
        if (this.cursor) {
            document.body.addEventListener('mouseenter', (e) => {
                gsap.to(this.cursor, { duration: 0.3, scale: 1 });
            });
            document.body.addEventListener('mouseleave', (e) => {
                gsap.to(this.cursor, { duration: 0.3, scale: 0 });
            });

            window.addEventListener('mousemove', (e) => {
                gsap.to(this.cursor, { top: e.clientY, left: e.clientX, duration: 0.05 });
            });
        }

        /** MAIN LOADER */
        const mainLoader = document.querySelector('.main-loader');
        if (mainLoader) {
            const tl = gsap.timeline({
                paused: true,
                onComplete: () => {
                    this.init();
                },
            });
            const step1 = mainLoader.querySelector('.step1');
            const step2 = mainLoader.querySelector('.step2');

            tl
                //.add('step1')
                // .to(step1, { autoAlpha : 1, duration: 1 }, 'step1')
                // .to(step1.querySelector('.bar'), { duration: 2, width: '100%', ease : 'expo.out' }, '-=0.1')
                // .to(step1, { autoAlpha : 0, duration: 0.6})
                .set(step2, { autoAlpha: 1 })
                .fromTo(
                    step2.querySelector('.logo-loader'),
                    { autoAlpha: 0, y: '-1rem' },
                    { autoAlpha: 1, y: '0rem', duration: 1.2, ease: 'expo.out' },
                    'step2',
                )
                .to(
                    step2.querySelector('.mask'),
                    { width: '50vmax', height: '50vmax', duration: 2.5, ease: 'circ.in' },
                    'step2',
                )
                .to(
                    step2.querySelectorAll('.elt'),
                    { stagger: 0.1, autoAlpha: 0, y: '-2rem', ease: 'circ.in' },
                    '+=1.75',
                )
                .to(mainLoader, { autoAlpha: 0, duration: 1 });

            tl.play();
        } else {
            this.init();
        }

        if (loader) {
            const tl = gsap.timeline({
                paused: true,
                onStart: () => {
                    if (mainLoader) {
                        gsap.set(mainLoader, { autoAlpha: 0 });
                    }
                },
            });
            tl.to(loader.querySelector('.logo'), { autoAlpha: 1, duration: 1 })
                .to(
                    loader.querySelector('.bar'),
                    { duration: 2, width: '100%', ease: 'expo.out' },
                    '-=0.2',
                )
                .add('+=0.35');

            loader.timeline = tl;
        }

        this.history();
    }

    init() {
        this.inViewport();
        this.form();
        this.carousel();
        // this.updateCursor();
        this.splitting();
        this.presentation();
    }

    updateCursor() {
        const _ = this;

        if (_.cursor) {
            const links = document.querySelectorAll('a, button');

            if (links) {
                function mouseEnter() {
                    gsap.to(_.cursor, { duration: 0.3, scale: 2.5 });
                }
                function mouseLeave() {
                    gsap.to(_.cursor, { duration: 0.3, scale: 1 });
                }

                links.forEach((el) => {
                    el.removeEventListener('mouseenter', mouseEnter);
                    el.removeEventListener('mouseleave', mouseLeave);
                    el.addEventListener('mouseenter', mouseEnter);
                    el.addEventListener('mouseleave', mouseLeave);
                });
            }
        }
    }

    splitting() {
        const elts = document.querySelectorAll('.animation-words');

        if (elts) {
            elts.forEach((el) => {
                const s = new SplitText(el, { type: 'words', wordsClass: 'word word++' });
                el.classList.add('ready');
                el.nextElementSibling.classList.add(`delay-${(s.words.length + 3) * 100}`);
            });
        }
    }

    history() {
        if (window.location.pathname.includes('checkout')) {
            console.log('pass chekout');
            return;
        }

        if (document.location.hash != '' && document.location.hash != '#') {
            this.loadPage(document.location.hash.replace('#', ''));
        }

        window.addEventListener('popstate', (event) => {
            if (
                document.location.hash != '' &&
                document.location.hash != '#' &&
                document.location.hash.indexOf('#/') >= 0
            ) {
                this.loadPage(document.location.hash.replace('#', ''));
                return false;
            } else {
                this.closePopin();
            }
        });
    }

    closePopin() {
        HTML.classList.remove('open-popin');
        history.pushState('', document.title, window.location.pathname + window.location.search);
        const popins = document.querySelectorAll('.popin');

        if (popins) {
            popins.forEach((popin) => {
                gsap.to(popin, {
                    duration: 0.5,
                    autoAlpha: 0,
                    onComplete: () => {
                        popin.remove();
                    },
                });
            });
        }
    }

    loadPage(url) {
        const _ = this;
        if (loader) {
            loader.classList.remove('opacity-0', 'invisible');
            setTimeout(() => {
                loader.timeline.play();
            }, 400);
        }

        HTML.classList.add('open-popin');

        fetch(url)
            .then(function (response) {
                return response.text();
            })
            .then(function (data) {
                if (data != '') {
                    const html = document.createElement('div');
                    html.innerHTML = data;

                    // Create popin
                    const popin = document.createElement('div');
                    popin.classList.add('popin');
                    popin.append(html.querySelector('.main'));

                    // Close trigger
                    const close = popin.querySelector('.close-popin');
                    if (close) {
                        close.addEventListener('click', (e) => {
                            e.preventDefault();
                            _.closePopin();
                        });
                    }

                    document.body.append(popin);

                    const form = popin.querySelector('.wpcf7 form');
                    if (form) wpcf7.init(form);

                    setTimeout(() => {
                        gsap.to(popin, {
                            duration: 0.2,
                            autoAlpha: 1,
                            onComplete: () => {},
                        });
                        // popin.classList.add("show");
                        _.lazyload.update();

                        if (loader) {
                            let timerLoader = 0;
                            timerLoader = setInterval(() => {
                                if (loader.timeline.progress() >= 1) {
                                    loader.classList.add('opacity-0', 'invisible');
                                    clearInterval(timerLoader);

                                    _.init();

                                    setTimeout(() => {
                                        loader.timeline.pause();
                                        loader.timeline.seek(0);
                                    }, 350);

                                    popin.addEventListener('scroll', (e) => {
                                        window.dispatchEvent(new Event('scroll'));
                                    });
                                }
                            }, 100);
                        }
                    }, 100);
                }
            })
            .catch(function (error) {
                alert(`Il y a eu un problème avec du chargement de la page : ${error.message}`);
                if (loader) loader.classList.add('opacity-0', 'invisible');
            });
    }

    form() {
        const inputs = document.querySelectorAll('input, textarea');
        if (inputs) {
            inputs.forEach((input) => {
                const parent = input.closest('.form-item');

                if (parent) {
                    if (input.value != '') parent.classList.add('fill');

                    input.addEventListener('focus', (e) => {
                        parent.classList.add('fill');
                    });
                    input.addEventListener('blur', (e) => {
                        if (input.value != '') {
                            parent.classList.add('fill');
                        } else {
                            parent.classList.remove('fill');
                        }
                    });
                }
            });
        }
    }

    carousel() {
        const carousels = document.querySelectorAll('.carousel');

        if (carousels) {
            carousels.forEach((carousel) => {
                const flkty = new Flickity(carousel, {
                    watchCSS: true,
                    cellAlign: 'center',
                    contain: true,
                    prevNextButtons: false,
                    pageDots: false,
                    initialIndex: 1,
                });
            });
        }
    }

    inViewport() {
        // In viewport
        inView.offset(window.innerHeight * 0.05);
        inView('.js-reveal:not(.is-visible)')
            .on('enter', function (elt) {
                elt.dispatchEvent(new Event('inview'));
                elt.classList.add('is-visible');
                elt.classList.remove('not-visible');

                const video = elt.querySelector('video');
                if (
                    (elt.tagName === 'VIDEO' &&
                        elt.dataset.autoplay !== '' &&
                        elt.dataset.autoplay !== undefined) ||
                    (video && video.dataset.autoplay !== '' && video.dataset.autoplay !== undefined)
                ) {
                    const v = video || elt;
                    const playPromise = v.play();
                    if (playPromise !== null) {
                        playPromise.catch(() => {
                            v.play();
                        });
                    }
                }
            })
            .on('exit', function (elt) {
                const video = elt.querySelector('video');
                if (
                    (elt.tagName === 'VIDEO' &&
                        elt.dataset.autoplay !== '' &&
                        elt.dataset.autoplay !== undefined) ||
                    (video && video.dataset.autoplay !== '' && video.dataset.autoplay !== undefined)
                ) {
                    const v = video || elt;
                    // v.pause();
                }

                elt.dispatchEvent(new Event('outview'));
                elt.classList.add('not-visible');
            });
    }

    presentation() {
        const elts = document.querySelectorAll('.presentation');

        if (elts) {
            elts.forEach((el) => {
                let current = -1;

                function goto(index) {
                    if (index == current) return;

                    if (items[current]) {
                        gsap.to(imgs[current], {
                            duration: 0.7,
                            autoAlpha: 0,
                            filter: 'blur(16px)',
                        });
                        gsap.to(items[current].querySelector('.wysiwyg'), {
                            duration: 0.4,
                            autoAlpha: 0.3,
                        });
                        gsap.to(items[current].querySelector('.line'), {
                            duration: 0.4,
                            ease: 'circ.inOut',
                            scaleY: 0,
                            transformOrigin: 'bottom center',
                        });
                    }

                    gsap.fromTo(
                        imgs[index],
                        { autoAlpha: 0, filter: 'blur(16px)' },
                        { duration: 0.7, filter: 'blur(0px)', autoAlpha: 1 },
                    );
                    gsap.to(items[index].querySelector('.wysiwyg'), {
                        duration: 0.3,
                        autoAlpha: 1,
                    });
                    gsap.to(items[index].querySelector('.line'), {
                        duration: 0.4,
                        ease: 'circ.inOut',
                        scaleY: 1,
                        transformOrigin: 'top center',
                    });

                    current = index;
                }

                const imgs = el.querySelectorAll('.presentation-img');
                const items = el.querySelectorAll('.presentation-item');

                el.addEventListener('inview', () => {
                    goto(0);
                });

                if (items) {
                    items.forEach((item, i) => {
                        item.addEventListener('mouseenter', () => {
                            goto(i);
                        });
                    });
                }
            });
        }
    }
}

window.addEventListener('load', () => {
    new App();
});
